

//!  NOT USED


import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import WbcLogo from '../../assets/images/wbc-logo-white-web.png';
import TecoLogo from '../../assets/images/teco_logo.png';
import NavBar from './NavBar';
import { BRAND_COLORS, COPYRIGHT } from '../../appConsts';


const AccountLayout = ({ children }) => {


    useEffect(() => {
        if (document.body) document.body.classList.add('authentication-bg');

        return () => {
            if (document.body) document.body.classList.remove('authentication-bg');
        };
    }, []);

    return (
        <>
            <div style={{ backgroundColor: BRAND_COLORS.PRIMARY }}>
                <NavBar />
            </div>

            <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5} xxl={4}>
                            <Card>
                                {/* logo */}
                                <Card.Header className="pt-4 pb-4 text-center bg-light">
                                    <Link to="/">
                                        <span>
                                            <img src={TecoLogo} alt="" height="62" />
                                        </span>
                                    </Link>
                                </Card.Header>
                                <Card.Body className="p-4">{children}</Card.Body>
                            </Card>

                        </Col>
                    </Row>
                </Container>
            </div>
            <footer className="footer footer-alt">{COPYRIGHT}</footer>
        </>
    );
};

export default AccountLayout;
